/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { ApiProvider, Constants } from '@leverege/api-redux';
import { Groupings } from '@leverege/molten/groupings';

/**
 * This will load data from API and make it available as items to the actual renderer
 */
import { jsx as _jsx } from "react/jsx-runtime";
class LoadDataRenderer extends React.Component {
  static contextType = ApiProvider.Context;
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      items: null
    };
    this.lastConvert = {
      items: []
    };
  }
  componentDidMount() {
    this.loadData();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const {
      sectionsState,
      model
    } = this.props;
    if (!Groupings.areSelectionsEqual(prevProps.sectionsState, sectionsState) || model?.visible !== prevProps.model?.visible || model?.customFilters?.includeOutdoorZones !== prevProps.model?.customFilters?.includeOutdoorZones || model?.customFilters?.includeIndoorZonesRPSEnabled !== prevProps.model?.customFilters?.includeIndoorZonesRPSEnabled || model?.customFilters?.includeIndoorZonesRPSDisabled !== prevProps.model?.customFilters?.includeIndoorZonesRPSDisabled) {
      this.loadData();
    }
  }
  componentWillUnmount() {
    this.isUnmounted = true;
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }
  createDataItems = results => {
    const {
      relationship,
      childPath
    } = this.props;
    const {
      childRef
    } = this.state;
    const page = 0;
    const perPage = results?.limit || 100;
    const type = relationship.objectType;
    const ref = childPath ? childRef : relationship.ref; // delegate.getInterfaceUrl( )

    const {
      items
    } = results || {};
    return {
      status: results?.status || null,
      loading: results?.status === 'api.interface.status.loading',
      perPage,
      page,
      count: results?.total || 0,
      items: items == null ? [] : items.map(device => {
        if (device == null) {
          return device;
        }
        return {
          type,
          ref,
          id: device.id,
          data: device
        };
      })
    };
  };
  getItems() {
    const {
      items: pItems,
      /* item, relationship, */childPath,
      grouping
    } = this.props;
    let items = pItems;
    if (childPath && grouping) {
      items = this.state.items; // eslint-disable-line
    }
    if (items === this.lastItems) {
      return this.lastConvert;
    }
    this.lastConvert = this.createDataItems(items);
    this.lastItems = items;
    return this.lastConvert;
  }
  buildImagineFilter(customFilters) {
    return {
      type: 'logical',
      operator: 'or',
      conditions: [...(customFilters.includeOutdoorZones ? [{
        type: 'equals',
        field: 'data/environment',
        value: ['outdoors']
      }] : []), ...(customFilters.includeIndoorZonesRPSEnabled ? [{
        type: 'logical',
        operator: 'and',
        conditions: [{
          type: 'equals',
          field: 'data/environment',
          value: ['indoors']
        }, {
          type: 'equals',
          field: 'data/rps/enabled',
          value: [true]
        }]
      }] : []), ...(customFilters.includeIndoorZonesRPSDisabled ? [{
        type: 'logical',
        operator: 'and',
        conditions: [{
          type: 'equals',
          field: 'data/environment',
          value: ['indoors']
        }, {
          type: 'logical',
          operator: 'or',
          conditions: [{
            type: 'equals',
            field: 'data/rps/enabled',
            value: [false]
          }, {
            type: 'exists',
            field: 'data/rps/enabled',
            not: true
          }]
        }]
      }] : [])]
    };
  }
  async loadData() {
    const {
      dispatch,
      delegate,
      childPath,
      fallbackChildPath,
      sectionsState,
      grouping,
      groupingId,
      model
    } = this.props;
    const api = this.context;
    if (model?.visible === false || this.isUnmounted) {
      return;
    }
    if (typeof childPath === 'string') {
      if (!Groupings.isGroupingEmpty(grouping)) {
        // load from 
        const rcp = resolveUrl(childPath, sectionsState, delegate.id, groupingId);
        try {
          if (rcp == null) {
            this.setState({
              items: null,
              childRef: rcp
            });
          } else {
            const res = await api.child('v1/interface/').child(rcp).get({
              perPage: 1000
            });
            this.addItemsToReduxAndSetState(res, rcp);
          }
        } catch (err) {
          console.error(err); // eslint-disable-line no-console
          this.setState({
            items: null,
            childRef: rcp
          });
        }
      } else if (fallbackChildPath) {
        try {
          const res = await api.child('v1/interface/').child(fallbackChildPath).get({
            perPage: 1000
          });
          this.addItemsToReduxAndSetState(res, fallbackChildPath);
        } catch (err) {
          console.error(err); // eslint-disable-line no-console
          this.setState({
            items: null,
            childRef: fallbackChildPath
          });
        }
      }
    } else if (delegate.list) {
      const filter = this.buildImagineFilter(model.customFilters);
      if (filter.conditions.length > 0) {
        dispatch(delegate.search({
          filter,
          limit: 1000
        })).catch(console.log);
      } else {
        dispatch(delegate.list({
          filter,
          limit: 0
        })).catch(console.log);
      }
      // eslint-disable-line no-console
    } else if (delegate.get) {
      dispatch(delegate.get()).catch(console.log); // eslint-disable-line no-console
    } else {
      // eslint-disable-next-line no-console
      console.warn('Loader action does not have a list', delegate);
    }
  }
  addItemsToReduxAndSetState(res, rcp) {
    const {
      dispatch
    } = this.props;
    if (this.isUnmounted) {
      return;
    }
    if (res && Array.isArray(res.items)) {
      dispatch({
        type: Constants.INTERFACE_LIST,
        data: res,
        path: rcp
      });
      this.setState({
        items: res,
        childRef: rcp
      });
    } else {
      dispatch({
        type: Constants.INTERFACE_GET,
        data: res,
        path: `${rcp}/${res.id}`
      });
      this.setState({
        items: {
          items: [res]
        },
        childRef: rcp
      });
    }
  }
  render() {
    const {
      renderer: Renderer
    } = this.props;
    return /*#__PURE__*/_jsx(Renderer, {
      ...this.props,
      items: this.getItems().items
    });
  }
}
export default connect((state, props) => {
  const {
    delegate
  } = props;
  return {
    items: delegate.getList?.(state, {
      getAll: true
    }),
    grouping: Groupings.getGrouping(state) || null,
    groupingId: Groupings.getCurrentGroupingId(state) || null,
    sectionsState: Groupings.getSelectedSectionValues(state)
  };
})(LoadDataRenderer);
function resolveUrl(url, sectionsState, id, currentGroupingId) {
  const parts = url.split('/');
  const res = parts.map(val => {
    if (val.startsWith('${grouping:') && val.endsWith('}')) {
      const arr = val.substring(11, val.length - 1).split(':');
      const section = arr.length === 1 ? arr[0] : arr[1];
      return sectionsState?.[section];
    }
    // eslint-disable-next-line no-template-curly-in-string
    if (val === '${currentGrouping}') {
      return currentGroupingId;
    }
    return val;
  });
  if (res.some(v => v == null || Groupings.isAll(v) || Groupings.isMissing(v))) {
    return null;
  }
  return res.join('/');
}